import { render, staticRenderFns } from "./ColumnDesc.vue?vue&type=template&id=2eaf0d66&scoped=true&"
import script from "./ColumnDesc.vue?vue&type=script&lang=js&"
export * from "./ColumnDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eaf0d66",
  null
  
)

export default component.exports